export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5036.943277b6.jpg";